<template>
  <span>
    <b-icon
      :id="`popover-sections-${id_popover}`"
      :icon="icon"
      :variant="variant"
      class="popover-sections-icon"
      :class="custom_class"
    ></b-icon>

    <b-popover
      :target="`popover-sections-${id_popover}`"
      :triggers="triggers"
      :placement="placement"
      boundary="viewport"
      custom-class="info-popover-comparison-container"
    >
      <template #title>
        <div class="info-popover-sections-header">
          <b-icon v-if="title_icon" :icon="title_icon" class="mr-1"></b-icon>
          {{ title }}
        </div>
      </template>
      <div class="info-popover-sections-body">
        <div
          v-for="(section, sIndex) in sections"
          :key="'section-' + sIndex"
          class="info-popover-sections-section"
        >
          <div
            class="info-popover-sections-section-title"
            :style="{ color: section.header_color || '#495057' }"
          >
            <b-icon
              v-if="section.header_icon"
              :icon="section.header_icon"
              class="mr-1"
            ></b-icon>
            {{ section.title }}
          </div>
          <p v-if="section.description" class="info-popover-sections-desc">
            {{ section.description }}
          </p>
          <ul
            v-if="section.items && section.items.length"
            class="info-popover-sections-list"
          >
            <li v-for="(item, iIndex) in section.items" :key="'item-' + iIndex">
              {{ item }}
            </li>
          </ul>
          <div
            v-if="section.alert"
            class="info-popover-sections-alert"
            :class="
              'info-popover-sections-alert-' + (section.alert_type || 'info')
            "
          >
            <b-icon
              v-if="section.alert_icon"
              :icon="section.alert_icon"
              class="mr-1"
            ></b-icon>
            {{ section.alert }}
          </div>
        </div>
      </div>
    </b-popover>
  </span>
</template>

<script>
export default {
  name: "InfoPopoverComparison",
  props: {
    id_popover: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    title_icon: {
      type: String,
      default: "",
    },
    sections: {
      type: Array,
      required: true,
      // Cada sección: {
      //   title, header_icon, header_color,
      //   description,
      //   items: [],
      //   alert, alert_icon, alert_type: 'warning'|'success'|'info'
      // }
    },
    icon: {
      type: String,
      default: "info-circle-fill",
    },
    variant: {
      type: String,
      default: "primary",
    },
    custom_class: {
      type: String,
      default: "",
    },
    triggers: {
      type: String,
      default: "hover focus",
    },
    placement: {
      type: String,
      default: "right",
    },
  },
};
</script>

<style scoped>
.popover-sections-icon {
  cursor: help;
}
</style>

<!--
  Estilos globales (NO scoped) — necesarios porque b-popover
  renderiza su contenido en el <body>, fuera del scope del componente.
  Se usa custom-class="info-popover-comparison-container" como namespace
  para evitar colisiones con otros estilos.
-->
<style>
.info-popover-comparison-container {
  max-width: 420px;
}
.info-popover-comparison-container .popover-header {
  background-color: #3162a4 !important;
  color: #fff;
  font-size: 0.85rem;
  padding: 0.5rem 0.75rem;
}
.info-popover-comparison-container .popover-body {
  padding: 0;
}
.info-popover-comparison-container .info-popover-sections-header {
  display: flex;
  align-items: center;
}
.info-popover-comparison-container .info-popover-sections-body {
  font-size: 0.8rem;
}
.info-popover-comparison-container .info-popover-sections-section {
  padding: 0.6rem 0.75rem;
}
.info-popover-comparison-container
  .info-popover-sections-section
  + .info-popover-sections-section {
  border-top: 1px solid #e9ecef;
}
.info-popover-comparison-container .info-popover-sections-section-title {
  font-weight: 700;
  font-size: 0.82rem;
  margin-bottom: 0.3rem;
  display: flex;
  align-items: center;
}
.info-popover-comparison-container .info-popover-sections-desc {
  margin: 0 0 0.35rem 0;
  color: #495057;
  line-height: 1.35;
}
.info-popover-comparison-container .info-popover-sections-list {
  margin: 0 0 0.35rem 0;
  padding-left: 1.2rem;
  color: #495057;
}
.info-popover-comparison-container .info-popover-sections-list li {
  margin-bottom: 0.1rem;
  line-height: 1.35;
}
.info-popover-comparison-container .info-popover-sections-alert {
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  font-size: 0.78rem;
  display: flex;
  align-items: flex-start;
}
.info-popover-comparison-container .info-popover-sections-alert-warning {
  background-color: #fff3cd;
  color: #856404;
}
.info-popover-comparison-container .info-popover-sections-alert-success {
  background-color: #d4edda;
  color: #155724;
}
.info-popover-comparison-container .info-popover-sections-alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
}
.info-popover-comparison-container .info-popover-sections-footer {
  background-color: #e2e3e5;
  color: #383d41;
  padding: 0.4rem 0.75rem;
  font-size: 0.78rem;
  border-top: 1px solid #e9ecef;
  display: flex;
  align-items: center;
}
</style>
